var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-editor"},[_c('WidgetSelector',{attrs:{"main-widget":_vm.mainWidget,"options":_vm.options},on:{"select":widget => _vm.$emit('change-widget', widget)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }